import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

const DetailsTab: React.FC = () => {
  return (
    <div className='h-28 w-[800px] min-w-[800px] space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mẫu báo cáo:</Label>
          <div className='w-1/2'>
            <FormField
              name='mau_bc'
              type='select'
              options={[
                { value: 'TC', label: 'Mẫu tiền chuẩn' },
                { value: 'NT', label: 'Mẫu ngoại tệ' }
              ]}
              className='w-full'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
